/* eslint no-console: 0 */

import Vue from 'vue'
import Poi from '../poi.vue'

document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector("#poi"),
        data = el.dataset;
  const app = new Vue({
    el,
    render(h){
      return h(Poi, {
        props: {
          page: JSON.parse(data.page),
          id: parseInt(data.id),
          pageNo: parseInt(data.pageno),
          config: JSON.parse(data.config),
          nearby: JSON.parse(data.nearby),
          loc: JSON.parse(data.loc),
          crumbs: JSON.parse(data.crumbs),
          links: JSON.parse(data.links),
          seoText: JSON.parse(data.text),
          wknd: data.wknd,
          searchLink: data.search
        }
      });
    }
  });
});
